import React from 'react';
import log from 'loglevel';
import styled from '@emotion/styled';
import { IQuickLinkItem } from './IQuickLinkItem';
import { QuickLinkAsset } from './QuickLinkAsset';
import { QuickLinkEmail } from './QuickLinkEmail';
import { QuickLinkExternal } from './QuickLinkExternal';
import { QuickLinkInternal } from './QuickLinkInternal';
import { FixedGrid, IFixedGridProps } from '../Grid';
import { QuickLinkItem } from './QuickLinkItem';
import { ITheme } from '../../themer';
import { QuickLinkPhone } from './QuickLinkPhone';

export const StyledQuickLinks = styled(FixedGrid)<IFixedGridProps, ITheme>`
	margin-top: 0;
`;

export function renderQuickLinksItem({ key, ...item }: IQuickLinkItem) {
	switch (item.type) {
		case 'asset-link':
			return <QuickLinkAsset key={key} {...item} />;

		case 'email-link':
			return <QuickLinkEmail key={key} {...item} />;

		case 'external-link':
			return <QuickLinkExternal key={key} {...item} />;

		case 'internal-link':
			return <QuickLinkInternal key={key} {...item} />;

		case 'phone-link':
			return <QuickLinkPhone key={key} {...item} />;

		default:
			const invalidItem: never = item;
			log.warn(
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				`Invalid quick link item type ${(invalidItem as any).type}`,
				invalidItem,
			);
			return null;
	}
}

export interface IQuickLinksProps extends IFixedGridProps {
	items: IQuickLinkItem[];
	renderItem?: (item: IQuickLinkItem) => React.JSX.Element;
}

export function QuickLinks({
	items,
	columns,
	renderItem: customRenderItem,
}: IQuickLinksProps) {
	const renderItem = customRenderItem || renderQuickLinksItem;

	return (
		<StyledQuickLinks columns={columns} itemSelector={QuickLinkItem}>
			{items.map(renderItem)}
		</StyledQuickLinks>
	);
}
